import React from "react";
import { ARGB_To_RGBA_Color } from "../constants";
import PropTypes from "prop-types";

function TextBlock(props) {
  const { item, fType } = props;
  const checkAcordColor =
    fType === "NonAcord"
      ? ARGB_To_RGBA_Color(item.Foreground)
      : item.Foreground;
  const getColor = item.Foreground ? checkAcordColor : "black";
  return (
    <span
      style={{
        width: item.Width ? item.Width : "auto",
        height: item.Height ? item.Height : "auto",
        position: "absolute",
        top: item.SetTop,
        left: item.SetLeft,
        fontFamily: item.FontFamily,
        fontSize: item.FontSize,
        fontStyle: item.FontStyle,
        fontWeight: item.FontWeight,
        textAlign: item.TextAlignment,
        textDecoration: item.TextDecorations,
        color: getColor,
      }}
    >
      {item.Text?.split(/[\r\n]+/).map((line, index) => (
        <span key={`${item.SetLeft}-${item.SetTop}`}>
          {line}
          {index < item.Text.split(/[\r\n]+/).length - 1 && <br />}
        </span>
      ))}
    </span>
  );
}

TextBlock.propTypes = {
  fType: PropTypes.string,
  item: PropTypes.shape({
    Foreground: PropTypes.string,
    Width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    SetTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    SetLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    FontFamily: PropTypes.string,
    FontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    FontStyle: PropTypes.string,
    FontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    TextAlignment: PropTypes.string,
    TextDecorations: PropTypes.string,
    Text: PropTypes.string,
  }).isRequired,
};

TextBlock.defaultProps = {
  fType: "",
};

export default TextBlock;
